import { $http, buildHeaders } from "./index";

//获取供应商列表
export const supplier_list = (params) => {
  return $http.get("/admin/Supplier/index", { params });
};

//获取供应商列表
export const supplier_select = () => {
  return $http.get("/admin/Supplier/index", {
    params: { limit: 0, sort_field: "name", status: 1 },
  });
};

//获取供应商详情
export const supplier_detail = (id) => {
  return $http.get("/admin/Supplier/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加供应商
export const supplier_add = (data) => {
  return $http.post("/admin/Supplier/add", data, {
    headers: buildHeaders(3),
  });
};

//修改供应商
export const supplier_edit = (data) => {
  return $http.post("/admin/Supplier/edit", data, {
    headers: buildHeaders(3),
  });
};

//删除供应商
export const supplier_delete = (id) => {
  return $http.post(
    "/admin/Supplier/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取结算单位列表
export const settleunit_list = (params) => {
  return $http.get("/admin/SettleUnit/index", { params });
};

//获取结算单位详情
export const settleunit_detail = (id) => {
  return $http.get("/admin/SettleUnit/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加结算单位
export const settleunit_add = (data) => {
  return $http.post("/admin/SettleUnit/add", data, {
    headers: buildHeaders(3),
  });
};

//修改结算单位
export const settleunit_edit = (data) => {
  return $http.post("/admin/SettleUnit/edit", data, {
    headers: buildHeaders(3),
  });
};

//删除结算单位
export const settleunit_delete = (id) => {
  return $http.post(
    "/admin/SettleUnit/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取供应商算税单
export const calctax_list = (params) => {
  return $http.get("/admin/Supplier/calcTax", { params });
};
